module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("GAIA")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_c('strong', [_vm._v("Mary’s")]), _vm._v(" dead")]), _vm._v(". Maybe if I say it over and over a thousand times, it’ll sink in. "), _c('em', [_vm._v("Mary’s dead")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve been sitting in this tub for more than an hour now. I’m shivering and the water’s cold, but I can’t seem to move. I keep seeing Mary’s face. Keep feeling her hair in my hands. There was blood on her teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Mary’s dead")]), _vm._v(". I held her tonight as her eyes closed. Her life flowed out onto the cobblestone pavement of Washington Square Park. I saw who did it. I even fought him. Mary’s old dealer, Skizz, hired that guy to kill Mary. Which he did, tonight.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Oh God, Mary’s really dead. She won’t call me tomorrow. I’m shaking and sore and Mary’s blood washed off into this bathwater when I stepped in. She won’t ever make me wear ridiculous clothes again. Make me go dancing with her. ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Tell me her secrets. Listen when I tell her mine.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("What do I do now? Everything I touch gets destroyed. What does that mean for Ed? I can’t seem to get out of this tub. I’m curled up. The porcelain is hard and cold under my head. I’m shaking. I don’t want to cry, can’t cry, can’t make noise. Don’t want Ella to come up here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Oh God, Mary’s dead")]), _vm._v(". Is it too much for me to have a friend? Is it too much for me to trust someone? Is it too much for me to be close to someone?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I need to think. Think this through. Thinking is better than screaming. Better than crying. Better than feeling all this "), _c('em', [_vm._v("pain")]), _vm._v(". I can’t stand this pain. I don’t want to feel this. I’ve got to stop this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Breathe, breathe, breathe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Okay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No more.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("I have to find a way to never feel like this again. Not because ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("of my mom, or my dad, or Mary, or anyone. I’ve got to make sure I never, never feel this pain again.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("And I’ve got to make Skizz pay.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c53c630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 78
// module chunks = 0